import { Box } from '@mui/system'
import { MontageRoot } from '../three/scene'
import { K3Extensions } from '@k3/core'
import { ArticleList } from '../components/ArticleList'

export const useExtensions = () => {
  const extensions: K3Extensions = {
    app: {
      k3d: {
        root: () => () => {
          return <MontageRoot />
        },
      },
      priceTable: {
        root: (Wrapped) => (props) => {
          return <ArticleList {...props}></ArticleList>
        },
      },
      
      sidebar: {
        components: {
          select: (Wrapped) => (props) => {
            return <Wrapped {...props} onChange={props.onChange} />
          },

          radio: (Wrapped) => (props) => {
            return <Wrapped {...props} />
          },
        
        },
      },
    },
  }

  return { extensions }
}
